<template>
  <div>
    <DataLoader :is_on="loading" />
	<div class="sifarnik-top-line">
    <div class="crm-top cases-top">
      <div class="cases-top-left">
        <navigation-office-management :active_link=0></navigation-office-management>
      </div>
      </div>
            <div class="sifarnik-top-left">
                <!-- <RouteTab current_tab="Sifarnik" /> -->
            </div>
            <div class="sifarnik-top-right">
                <!-- <CustomDropdown style="margin-right:2rem;" :id="'drop_sifarnik_type'" v-model="sifra_type"
                    :drop_items="drop_items" /> -->


                <div class="upload-stavke-button upload-dokumenta-button " @click="openServiceTypeDialog()">
                    {{ $t('office_management.service_type.new_category') }}
                    <div class="upload-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                            <g>
                                <g>
                                    <path fill="#fff"
                                        d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" />
                                </g>
                            </g>
                        </svg>
                    </div>
                </div>
				
            </div>
        </div>
	<purchase-group-array :purchase_groups="purchaseGroups" :services="serviceTypes"
   @openAddNew = "openServiceGroupDialog" 
   @editModal="editServiceGroup"
   @refreshData="refreshData"
></purchase-group-array>
    <!-- Service Type Dialog -->
    <service-type-dialog
      ref="serviceTypeDialog"
      @create="createServiceType"
      @update="updateServiceType"
    ></service-type-dialog>

    <!-- Office Service Group Dialog -->
    <office-service-group-dialog
      ref="serviceGroupDialog"
      @refresh="refreshData"
	  :services=serviceTypes
    ></office-service-group-dialog>

    <!-- Buttons to open dialogs -->
    <!-- <v-btn @click="openServiceTypeDialog">Create Service Type</v-btn>
    <v-btn @click="openServiceGroupDialog">Create Service Group</v-btn> -->

    <!-- Example for editing, assuming you have a service type and group object to pass -->
    <!-- <v-btn @click="editServiceType(serviceType)">Edit Service Type</v-btn>
	  <v-btn @click="editServiceGroup(serviceGroup)">Edit Service Group</v-btn> -->

    <!-- List of data -->

    


  </div>
</template>

<script>
import {
  getAllPurchases,
  getAllServiceTypes,
  getAllPurchaseGroups,
  createServiceType,
  updateServiceType,
  createPurchaseGroup,
  updatePurchaseGroup,
} from "../../../../apiCallers/promise_handler_db/officeManagement";
import OfficeServiceGroupDialog from "../../../../components/officeManagement/OfficeServiceGroupDialog.vue";
import ServiceTypeDialog from "../../../../components/officeManagement/ServiceTypeDialog.vue";
import PurchaseCreateEdit from "../../../../components/officeManagement/PurchaseCreateEdit.vue";
import PurchaseGroupArray from '../../../../components/officeManagement/PurchaseGroupArray.vue';
import NavigationOfficeManagement from "../../../../components/officeManagement/NavigationOfficeManagement.vue";
import DataLoader from '../../../../components/generalComponents/DataLoader.vue';

export default {
  components: {
    OfficeServiceGroupDialog,
    ServiceTypeDialog,
    PurchaseCreateEdit,
    PurchaseGroupArray,
    NavigationOfficeManagement,
    DataLoader
  },
  data() {
    return {
      isActivePopup: false,
      isEditMode: false,
      purchases: [], // Array of purchases
      currentPurchaseIndex: 0, // Index of the current purchase being edited or viewed
      all_users: [], // Team members for responsible person selection
      purchaseCategories: [], // Categories of purchases
      serviceTypes: [],
	  purchaseGroups : [],
      purchaseData: {
        purchaseDate: "", // Empty string or use `new Date().toISOString().substring(0, 10)` for today's date
		    title : "",
        description: "",
        price : null,
		quantity : 1,
		acquired : false,
		person_id : null,
		service_type_id : true,

      },
      loading : true
    };
  },
  methods: {
 
    openPurchaseDialog() {
      this.isEditMode = false;
      this.isActivePopup = true;
      this.currentPurchaseIndex = -1; // Set to -1 for new purchase
    },
    editPurchase(index) {
      this.isEditMode = true;
      this.isActivePopup = true;
      this.currentPurchaseIndex = index; // Set index of the purchase to edit
    },
    closePopup() {
      this.isActivePopup = false;
    },
    openServiceTypeDialog() {
      this.$refs.serviceTypeDialog.open();
    },
    editServiceType(serviceType) {
      this.$refs.serviceTypeDialog.open(serviceType);
    },
    openServiceGroupDialog() {
		console.log("opening it")
      this.$refs.serviceGroupDialog.open();
    },
    editServiceGroup(serviceGroup) {
      this.$refs.serviceGroupDialog.open(serviceGroup);
    },
    async createServiceType(formData) {
      await createServiceType(formData);
      this.refreshData();
    },
    async updateServiceType(formData) {
      await updateServiceType(formData.id, formData);
      this.refreshData();
    },
    async createServiceGroup(formData) {
      await createPurchaseGroup(formData);
      this.refreshData();
    },
    async updateServiceGroup(formData) {
      console.log(formData);
      await updatePurchaseGroup(formData.id, formData);
      this.refreshData();
    },
    async getAllData() {
      await this.getAllPurchases();
      await this.getAllServiceTypes();
      await this.getAllPurchaseGroups();
    },
    
    async getAllPurchases() {
      const response = await getAllPurchases();
      this.purchases = response.data;
    },
    async getAllServiceTypes() {
      const response = await getAllServiceTypes();
      this.serviceTypes = response.data;
    },
    async getAllPurchaseGroups() {
      const response = await getAllPurchaseGroups();
      this.purchaseGroups = response.data;
    },
    async refreshData() {
      await this.getAllData()
    },
  },
  mounted() {
    this.refreshData();
    setTimeout(()=>{
          this.loading = false; 

    },1200)

	this.$store.state.paginacija.title = this.$t("breadcrumbs.office_mgmt");

  },
};
</script>
